import { createContext } from 'react';

const ResultContext = createContext();

export const ResultContextProvider = ResultContext.Provider;

export default ResultContext;
